import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { UserProfileDialogComponent } from '@modules/auth/user-profile-dialog/user-profile-dialog.component';
import { PersonFormComponent } from '@modules/person-profiles/person-form/person-form.component';
import { AuthService } from '@modules/auth/auth.service';
import { ConfigService } from '@modules/utility-components/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title: string = 'Loading...';
  showFiller: boolean = false;
  isMenuCollapsed: Boolean = false;
  showNavBar = true;
  links: any[];
  menu: any[] = [
    {label: "Loading Menu...", path: "/"}
  ];
  
  constructor(public dialog: MatDialog,
              public authSvc: AuthService,
              private configSvc: ConfigService,
              private titleSvc: Title,
              private route: ActivatedRoute,
               private router: Router
              ) {
    this.configSvc.settings.pipe(
      filter((settings) => settings.title)
    ).subscribe((settings: any) => this.titleSvc.setTitle(settings.title));
    combineLatest(this.authSvc.currentUser$, this.configSvc.settings).pipe(
      filter(([currentUser, settings]) => settings.userGroups)
    ).subscribe(([currentUser, settings]) => {
      this.links = [
        {label: "Activists & Donors", path: "/activists/new", groupPermissions: settings.userGroups},
        {label: "Donor Tables", path: "/donors", groupPermissions: ["Administrator"]},
     //   {label: "List Manager", path: "/list-manager", groupPermissions: settings.userGroups},
        {label: "File Importer", path: "/import-files", groupPermissions: ["Administrator"]},
        {label: "Users", path: "/users", groupPermissions: ["Administrator"]},
      ];
      if (this.authSvc.isLoggedIn()) {
        this.menu = this.links.filter(link => link.groupPermissions.includes(currentUser.user_group));
      }
    });
  }
  
  userProfileDialog = () => {
    let dialogRef = this.dialog.open(UserProfileDialogComponent, {position: {top: "70px", right: "30px"}});
  }
  onActivate = (event) => {
    this.showNavBar = !(event instanceof PersonFormComponent);
  }
}